module.exports = "/_next/static/images/ntuc-card-back-409fde0ff361f714cb6960dd51cdced8.png";